import { render } from "./portal.vue?vue&type=template&id=0a691c4f"
import script from "./portal.vue?vue&type=script&lang=js"
export * from "./portal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__